import { ReactNode } from 'react';

import { useTranslation } from '@/i18n';

import Button from '../../Button';
import { ModalContent, ModalFooter } from '../ModalContent';
import { useModals } from '../ModalManagerProvider';
import { ModalProps } from '../types';

type ConfirmationModalProps = {
  confirmButtonText?: string;
  isOnlyInfo?: boolean;
  message: ReactNode;
  negateButtonText?: string;
  onConfirm?: () => void;
  onNegate?: () => void;
} & ModalProps;

export default function ConfirmationModal({
  confirmButtonText,
  isOnlyInfo = false,
  message,
  negateButtonText,
  onConfirm,
  onNegate,
}: ConfirmationModalProps) {
  const { t } = useTranslation('common');
  const { closeModal } = useModals();

  const onConfirmHandler = () => {
    onConfirm?.();
    closeModal();
  };

  const onNegateHandler = () => {
    onNegate?.();
    closeModal();
  };

  return (
    <>
      {typeof message === 'string' && <div className="py-4 px-3 mb-0 f-20">{message}</div>}
      {typeof message !== 'string' && <ModalContent>{message}</ModalContent>}

      <ModalFooter>
        {!isOnlyInfo && <Button onClick={onNegateHandler} text={negateButtonText || t('no')} type="danger" />}
        <Button onClick={onConfirmHandler} text={confirmButtonText || t('yes')} type="primary" />
      </ModalFooter>
    </>
  );
}
